import React from "react";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import moment from "moment";
import DocumentsTabModal from './DocumentsTabModal';
import ActionCreators from "../../store/actions";
import guid from "../../store/helpers/guid";

const styles = theme => ({
    table: {
        minWidth: 600,
        display: "flex",
        justifyContent: "flex-start",
        height: "100%"
    },
    button: {
        width: 150,
        height: 150
    }
});

const DocumentsTab = props => {
    const {classes, rent, documents} = props;

    const yesOption = (data, doc) => {
        let czasOd = data.czas_od;
        let czasDo = data.czas_do;

        if (czasDo > czasOd) {
            props.updateState({czas_od: czasOd, czas_do: czasDo});
            props.update({...rent, ...{czas_od: czasOd, czas_do: czasDo}}, () => props.onDownloadDocumentsHandler(doc))
        } else {
            props.openSnackbar("Czas zakonczenia jest wczesniej niz czas rozpoczęcia")
        }
    };

    const noOption = (doc) => props.onDownloadDocumentsHandler(doc);

    return (
        <div className={classes.table}>
            <List>
                {documents && documents.map(doc => (
                    <DocumentsTabModal
                        key={guid()}
                        onDownloadDocumentsHandler={() => props.onDownloadDocumentsHandler(doc)}
                        yesOption={() => yesOption({czas_od: rent.czas_od, czas_do: moment().unix()}, doc)}
                        noOption={() => noOption(doc)}
                        doc={doc}
                    />
                ))}
            </List>
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators(ActionCreators, dispatch),
    };
};

const mapStateToProps = state => {
    return {
        token: state.authReducer.token
    };
};

export default withStyles(styles)(connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentsTab));
